var config = {
  manageAuthHeader: true,
  setAuthHeader: function setAuthHeader(headers, accessToken) {
    if (accessToken) {
      headers.common.Authorization = "Bearer ".concat(accessToken);
    } else {
      delete headers.common.Authorization;
    }
  }
};
export default config;